/** @format */

import PhoneIcon from '@/assets/joivy_icon_app.svg';
import ColivingIcon from '@/assets/joivy_icon_colivers.svg';
import HeartIcon from '@/assets/joivy_icon_heart.svg';
import UtilitiesIcon from '@/assets/joivy_icon_utilities.svg';
import { TTranslation } from '@/i18n/createProvider';
import { useAppTranslation } from '@/i18n/declarations';
import React from 'react';
import styled from 'styled-components';

const RoomPremiumServices: React.FC = () => {
  const { t } = useAppTranslation();
  return (
    <div id="roomInfoAnchor">
      <CustomTitle dangerouslySetInnerHTML={{ __html: t('pdp.premium_services.title' as TTranslation) }} />
      <Services>
        <ServiceContainer>
          <Service>
            <img src={UtilitiesIcon} alt="utilities" role="presentation" width="36" />
            <p>{t('pdp.premium_services.title_services' as TTranslation)}</p>
          </Service>
        </ServiceContainer>
        <ServiceContainer>
          <Service>
            <img src={HeartIcon} alt="support" role="presentation" width="36" />
            <p>{t('pdp.premium_services.title_support' as TTranslation)}</p>
          </Service>
        </ServiceContainer>
        <ServiceContainer>
          <Service>
            <img src={ColivingIcon} alt="colivers" role="presentation" width="36" />
            <p>{t('pdp.premium_services.title_colivers' as TTranslation)}</p>
          </Service>
        </ServiceContainer>
        <ServiceContainer>
          <Service>
            <img src={PhoneIcon} alt="app" role="presentation" width="36" />
            <p>{t('pdp.premium_services.title_app' as TTranslation)}</p>
          </Service>
        </ServiceContainer>
      </Services>
    </div>
  );
};

const CustomTitle = styled.h2`
  margin-block: 0 0.75rem;
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  font-size: clamp(1.125rem, 1.0417rem + 0.3704vw, 1.375rem);
  letter-spacing: clamp(0.0225rem, 0.0208rem + 0.0074vw, 0.0275rem);

  span {
    font-family: ${({ theme }) => theme.font.subtitle};
    font-weight: 700;
    color: ${({ theme }) => theme.colors.joivy.pink};
    font-size: clamp(1.3125rem, 1.2071rem + 0.4826vw, 1.7969rem);
    line-height: clamp(1.3125rem, 1.2071rem + 0.4826vw, 1.7969rem);
    letter-spacing: clamp(0.01875rem, 0.0174rem + 0.0062vw, 0.020625rem);
  }
`;

const ServiceContainer = styled.div`
  width: 50%;
  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    width: 100%;
  }
  &:nth-child(odd) {
    padding-right: 8px;
    @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
      padding-right: 0px;
    }
  }
  &:nth-child(even) {
    padding-left: 8px;
    @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
      padding-left: 0px;
    }
  }
`;

const Service = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.joivy['teal-dark']};
  border-radius: 0.94rem;
  max-height: 4.375rem;
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};

  p {
    text-wrap: balance;
  }
`;

const Services = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 25px 0;
`;

export default RoomPremiumServices;
